import { SmimeCert } from "@dashboard-v3/api";

export default function isExpired(certificate: SmimeCert): boolean {
  return new Date(certificate.validUntil) < new Date();
}
